export const SkeletonCarousel = () => {
  return (
    <div className="container">
      <div className="placeholder-glow">
        <div className="p-3 mb-2 placeholder col-6 col-md-2"></div>
      </div>
      <div className="row gap-3 placeholder-glow">
        <div className="rounded placeholder col g-0 min-height-16em"></div>
        <div className="rounded placeholder col g-0 min-height-16em"></div>
        <div className="d-none d-md-block rounded placeholder col g-0 min-height-16em"></div>
      </div>
    </div>
  );
};
